
import { distinctUntilChanged } from 'rxjs/operators'
import { Action } from 'actions'
import { Observable } from 'rxjs'
import { generate } from 'randomstring'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'

export const distinctByField = <A extends Action> (field: string) => (source: Observable<A>): Observable<A> => {
  return source.pipe(distinctUntilChanged((a, b) => {
    const defaultA = generate()
    const defaultB = generate()
    const valueA = get(a, field, defaultA)
    const valueB = get(b, field, defaultB)

    if (valueA === defaultA || valueB === defaultB) {
      return false
    }
    return isEqual(valueA, valueB)
  }))
}
